import { KycVerificationListConstants } from "../_constants/kycVerificationList.constants";
import { alertActions } from "./alert.actions";
import {
  APIcallFunction,
  headerForPrivateAPI,
} from "../_helpers";

export const kycVerificationListActions = {
  kycVerificationList,
  kycUserDetails,
  updateKycStatus,
  merchantKycList,
  approveOrRejectMerchantKyc, viewRejectionsReasonsForMerchantKyc, approveOrRejectSubMerchant, viewRejectionsReasonsForKyc,
  viewRejectionsReasonsForBank, viewResolutionForDispute,kycExpiresList,convertToVerifiedMerchant
};

function kycVerificationList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/kyc/kycList",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        // dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: KycVerificationListConstants.GET_KYCVERIFICATION_LIST_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: KycVerificationListConstants.GET_KYCVERIFICATION_LIST_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: KycVerificationListConstants.GET_KYCVERIFICATION_LIST_FAILURE,
      error,
    };
  }
}





function kycExpiresList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/kyc/kycExpiresList",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        // dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: KycVerificationListConstants.GET_KYC_EXPIRE_LIST_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: KycVerificationListConstants.GET_KYC_EXPIRE_LIST_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: KycVerificationListConstants.GET_KYC_EXPIRE_LIST_FAILURE,
      error,
    };
  }
}







function kycUserDetails(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/getUserKycDetails",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: KycVerificationListConstants.GET_USERKYCDETAILS_LIST_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: KycVerificationListConstants.GET_USERKYCDETAILS_LIST_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: KycVerificationListConstants.GET_USERKYCDETAILS_LIST_FAILURE,
      error,
    };
  }
}



function merchantKycList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/merchantKyc/merchantKycList",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: KycVerificationListConstants.GET_MERCHANT_KYC_LIST_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: KycVerificationListConstants.GET_MERCHANT_KYC_LIST_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: KycVerificationListConstants.GET_MERCHANT_KYC_LIST_FAILURE,
      error,
    };
  }
}











function updateKycStatus(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/kyc/updateKycStatus",
  };
  return APIcallFunction(credentials)
}


function approveOrRejectMerchantKyc(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/merchantKyc/approveOrRejectMerchantKyc",
  };
  return APIcallFunction(credentials)
}


function convertToVerifiedMerchant(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/merchantKyc/convertToVerifiedMerchant",
  };
  return APIcallFunction(credentials)
}


function viewRejectionsReasonsForMerchantKyc(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/merchantKyc/viewRejectionsReasonsForMerchantKyc",
  };
  return APIcallFunction(credentials)
}


function approveOrRejectSubMerchant(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/webStore/approveOrRejectSubMerchant",
  };
  return APIcallFunction(credentials)
}


function viewRejectionsReasonsForKyc(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/kyc/viewRejectionsReasonsForKyc",
  };
  return APIcallFunction(credentials)
}


function viewRejectionsReasonsForBank(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/userBankDetails/viewRejectionsReasonsForBank",
  };
  return APIcallFunction(credentials)
}


function viewResolutionForDispute(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/order/viewResolutionForDispute",
  };
  return APIcallFunction(credentials)
}